import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { TableCell } from 'components/shared/widget'
import { ProbeLot } from 'entities/probe_lot'
import { ReactNode, useMemo } from 'react'
import { Form } from 'utils/hooks'
import { ProbeLotViewModel } from 'view_models/probe_lot_view_model'

export const probeLotColumnInfoList = (form?: Form<Record<string, unknown>>): ColumnInfoList => {
    return {
        tableName: '',
        values: [
            { name: 'LotNo.', th: true, width: 150, form: form, orderAttr: 'probe_lot_number', searchType: { name: 'lot_number', type: 'number' } },
            { name: 'Date', th: true, width: 150, form: form, orderAttr: 'probe_lot_date', searchType: { name: 'date', type: 'date' } },
            { name: 'Note', th: true, minWidth: 300, form: form, orderAttr: 'probe_lot_note', searchType: { name: 'note', type: 'text' } },
        ],
    }
}

export type ProbeLotTableDataProps = {
    probeLot?: ProbeLot
    displaySetting: DisplaySetting
}

export const ProbeLotTableData = ({ probeLot, displaySetting }: ProbeLotTableDataProps): JSX.Element => {
    if (!probeLot) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }

    const createCells = useMemo(() => {
        const vm = new ProbeLotViewModel(probeLot)
        return (
            <>
                <TableCell>{probeLot.number}</TableCell>
                <TableCell>{vm.dateText()}</TableCell>
                <TableCell>{probeLot.note}</TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
